/* eslint-disable */
import {
  dimensionIndicatorComponent,
  memoEval,
  sceneEntityObjectPropertiesComponent,
  sceneEntityObjectRemoteMaterialOverrideComponent,
  sceneEntityRemoteObjectComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'

export const baseSingleLegComponents = [
  attachComponent
    .withComponent(sceneEntityRemoteObjectComponent, 'base', true)
    .withAlias('BaseSingleLeg')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$fileUrl, self.$objectName],
        ($fileUrl, $objectName) => ({
          fileUrl: $fileUrl,
          objectName: $objectName,
          dimensionUnit: 'inch',
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityRemoteObjectComponent, 'platform', true)
    .withAlias('BaseSingleLeg')
    .withGradualFilter({ active: self => self.$platformFilter })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$fileUrl, self.$platformObjectName],
        ($fileUrl, $platformObjectName) => ({
          fileUrl: $fileUrl,
          objectName: $platformObjectName,
          dimensionUnit: 'inch',
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectPropertiesComponent, 'base', true)
    .withAlias('BaseSingleLeg')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$offsetY,
            self.$widthShapekeyValue,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$lengthShapekeyValue,
            self.$lengthScaleZero,
            self.$lengthScaleOne,
            self.$scaleShapekeyValue,
            self.$scaleScaleZero,
            self.$scaleScaleOne,
          ],
        (
          $offsetY,
          $widthShapekeyValue,
          $widthScaleZero,
          $widthScaleOne,
          $lengthShapekeyValue,
          $lengthScaleZero,
          $lengthScaleOne,
          $scaleShapekeyValue,
          $scaleScaleZero,
          $scaleScaleOne
        ) => ({
          offsetY: $offsetY,
          morphTargetInfluences: {
            width: {
              value: $widthShapekeyValue,
              scaleZero: $widthScaleZero,
              scaleOne: $widthScaleOne,
            },
            length: {
              value: $lengthShapekeyValue,
              scaleZero: $lengthScaleZero,
              scaleOne: $lengthScaleOne,
            },
            scale: {
              value: $scaleShapekeyValue,
              scaleZero: $scaleScaleZero,
              scaleOne: $scaleScaleOne,
            },
          },
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectPropertiesComponent, 'platform', true)
    .withAlias('BaseSingleLeg')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$platformWidth,
            self.$platformWidthScaleZero,
            self.$platformWidthScaleOne,
            self.$platformLength,
            self.$platformLengthScaleZero,
            self.$platformLengthScaleOne,
          ],
        (
          $platformWidth,
          $platformWidthScaleZero,
          $platformWidthScaleOne,
          $platformLength,
          $platformLengthScaleZero,
          $platformLengthScaleOne
        ) => ({
          morphTargetInfluences: {
            width: {
              value: $platformWidth,
              scaleZero: $platformWidthScaleZero,
              scaleOne: $platformWidthScaleOne,
            },
            length: {
              value: $platformLength,
              scaleZero: $platformLengthScaleZero,
              scaleOne: $platformLengthScaleOne,
            },
          },
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'platform', true)
    .withAlias('BaseSingleLeg')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$platformRepeatX,
            self.$platformRepeatY,
          ],
        (
          $fileUrl,
          $finishColor,
          $textureUrl,
          $normalMapUrl,
          $roughnessMapUrl,
          $aoMapUrl,
          $materialRoughness,
          $materialMetalness,
          $materialEnvMapIntensity,
          $materialSpecularIntensity,
          $materialNormalScale,
          $materialReflectivity,
          $platformRepeatX,
          $platformRepeatY
        ) => ({
          materialsToOverride: ['SupportMaterial'],
          fileUrl: $fileUrl,
          materialName: 'SupportMaterial',
          color: $finishColor,
          textureUrl: $textureUrl,
          normalMapUrl: $normalMapUrl,
          roughnessMapUrl: $roughnessMapUrl,
          aoMapUrl: $aoMapUrl,
          roughness: $materialRoughness,
          metalness: $materialMetalness,
          envMapIntensity: $materialEnvMapIntensity,
          specularIntensity: $materialSpecularIntensity,
          normalScale: $materialNormalScale,
          reflectivity: $materialReflectivity,
          repeatX: $platformRepeatX,
          repeatY: $platformRepeatY,
        })
      )
    ),

  attachComponent
    .withComponent(dimensionIndicatorComponent, 'feetThicknessIndicator', true)
    .withAlias('BaseSingleLeg')
    .withGradualFilter({
      navigationStates: ['Shape', 'Base', 'Wood', 'Appearance', 'Accessories', 'Summary'],
      active: self => self.$feetThicknessIndicatorVisible,
    })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$feetThicknessIndicatorFixedX, self.$feetThicknessIndicatorStartZ, self.$feetThicknessIndicatorEndZ],
        ($feetThicknessIndicatorFixedX, $feetThicknessIndicatorStartZ, $feetThicknessIndicatorEndZ) => ({
          startX: $feetThicknessIndicatorFixedX,
          startY: 0,
          startZ: $feetThicknessIndicatorStartZ,
          endX: $feetThicknessIndicatorFixedX,
          endY: 0,
          endZ: $feetThicknessIndicatorEndZ,
          extrusionX: 12,
          extrusionY: 0,
          extrusionZ: 0,
          extrusionLineDashed: true,
          indicatorAlwaysVisible: false,
        })
      )
    ),

  attachComponent
    .withComponent(dimensionIndicatorComponent, 'baseThicknessIndicator', true)
    .withAlias('BaseSingleLeg')
    .withGradualFilter({
      navigationStates: ['Shape', 'Base', 'Wood', 'Appearance', 'Accessories', 'Summary'],
      active: self => self.$baseThicknessIndicatorVisible,
    })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$baseThicknessIndicatorFixedY,
            self.$baseThicknessIndicatorStartZ,
            self.$baseThicknessIndicatorEndZ,
            self.$baseThicknessIndicatorExtrusionX,
          ],
        (
          $baseThicknessIndicatorFixedY,
          $baseThicknessIndicatorStartZ,
          $baseThicknessIndicatorEndZ,
          $baseThicknessIndicatorExtrusionX
        ) => ({
          startX: 0,
          startY: $baseThicknessIndicatorFixedY,
          startZ: $baseThicknessIndicatorStartZ,
          endX: 0,
          endY: $baseThicknessIndicatorFixedY,
          endZ: $baseThicknessIndicatorEndZ,
          extrusionX: $baseThicknessIndicatorExtrusionX,
          extrusionY: 0,
          extrusionZ: 0,
          extrusionLineDashed: true,
          indicatorAlwaysVisible: false,
        })
      )
    ),

  attachComponent
    .withComponent(dimensionIndicatorComponent, 'platformWidthIndicator', true)
    .withAlias('BaseSingleLeg')
    .withGradualFilter({
      navigationStates: ['Shape', 'Base', 'Wood', 'Appearance', 'Accessories', 'Summary'],
      active: self => self.$platformWidthIndicatorVisible,
    })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$platformWidthIndicatorStartX,
            self.$platformWidthIndicatorEndX,
            self.$platformWidthIndicatorExtrusionZ,
          ],
        ($platformWidthIndicatorStartX, $platformWidthIndicatorEndX, $platformWidthIndicatorExtrusionZ) => ({
          startX: $platformWidthIndicatorStartX,
          startY: 0,
          startZ: 0,
          endX: $platformWidthIndicatorEndX,
          endY: 0,
          endZ: 0,
          extrusionX: 0,
          extrusionY: 0,
          extrusionZ: $platformWidthIndicatorExtrusionZ,
          extrusionLineDashed: true,
          indicatorAlwaysVisible: false,
        })
      )
    ),

  attachComponent
    .withComponent(dimensionIndicatorComponent, 'platformLengthIndicator', true)
    .withAlias('BaseSingleLeg')
    .withGradualFilter({
      navigationStates: ['Shape', 'Base', 'Wood', 'Appearance', 'Accessories', 'Summary'],
      active: self => self.$platformLengthIndicatorVisible,
    })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$platformLengthIndicatorStartZ,
            self.$platformLengthIndicatorEndZ,
            self.$platformLengthIndicatorExtrusionX,
          ],
        ($platformLengthIndicatorStartZ, $platformLengthIndicatorEndZ, $platformLengthIndicatorExtrusionX) => ({
          startX: 0,
          startY: 0,
          startZ: $platformLengthIndicatorStartZ,
          endX: 0,
          endY: 0,
          endZ: $platformLengthIndicatorEndZ,
          extrusionX: $platformLengthIndicatorExtrusionX,
          extrusionY: 0,
          extrusionZ: 0,
          extrusionLineDashed: true,
          indicatorAlwaysVisible: false,
        })
      )
    ),
]
